import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import MenuIcon from "@mui/icons-material/Menu";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import SearchIcon from "@mui/icons-material/Search";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import GridViewIcon from "@mui/icons-material/GridView";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import PauseCircleOutlineOutlinedIcon from "@mui/icons-material/PauseCircleOutlineOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RemoveIcon from "@mui/icons-material/Remove";
import CancelIcon from "@mui/icons-material/Cancel";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PushPinIcon from "@mui/icons-material/PushPin";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import NotificationsIcon from "@mui/icons-material/Notifications";
import EditIcon from "@mui/icons-material/Edit";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonIcon from "@mui/icons-material/Person";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import DoneIcon from "@mui/icons-material/Done";
import DeleteIcon from "@mui/icons-material/Delete";
import BluetoothIcon from "@mui/icons-material/Bluetooth";
import HomeIcon from "@mui/icons-material/Home";
import WifiIcon from "@mui/icons-material/Wifi";
import CableIcon from "@mui/icons-material/Cable";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import SettingsOutlinedIcon from "@mui/icons-material/Settings";
import PrintOutlinedIcon from "@mui/icons-material/Print";
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import InfoIcon from '@mui/icons-material/Info';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import QueryBuilderIcon from "@mui/icons-material/QueryBuilder";
import RefreshIcon from '@mui/icons-material/Refresh';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import ArrowForward from "@mui/icons-material/ArrowForward";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import LockIcon from '@mui/icons-material/Lock';

export const USBIcon = (props) => {
  return <CableIcon {...props} />
}

// export const NotificationsIcon = (props) => {
//   return <NotificationsActiveIcon {...props} />;
// };
export const MenuBurgerIcon = (props) => {
  return <MenuIcon {...props} />;
};
export const FormatListIcon = (props) => {
  return <FormatListBulletedIcon {...props} />;
};

export const SearchFontIcon = (props) => {
  return <SearchIcon {...props} />;
};

export const GridIcon = (props) => {
  return <GridViewIcon {...props} />;
};

export const QrFontIcon = (props) => {
  return <QrCodeScannerIcon {...props} />;
};

export const AddIcon = (props) => {
  return <AddOutlinedIcon {...props} />;
};

export const DeleteIconN = (props) => {
  return <DeleteForeverOutlinedIcon {...props} />;
};

export const PauseIcon = (props) => {
  return <PauseCircleOutlineOutlinedIcon {...props} />;
};

export const ThreeDotIcon = (props) => {
  return <MoreVertOutlinedIcon {...props} />;
};

export const DownArrowIcon = (props) => {
  return <KeyboardArrowDownIcon {...props} />;
};

export const MinusIcon = (props) => {
  return <RemoveIcon {...props} />;
};

export const ExitIcon = (props) => {
  return <CancelIcon {...props} />;
};

export const CirclTick = (props) => {
  return <TaskAltOutlinedIcon {...props} />;
};

export const BookMarkIcon = (props) => {
  return <BookmarkBorderOutlinedIcon {...props} />;
};

export const PrintIcon = (props) => {
  return <LocalPrintshopOutlinedIcon {...props} />;
};

export const CrossIcon = (props) => {
  return <CloseIcon {...props} />;
};

export const PinIcon = (props) => {
  return <PushPinIcon {...props} />;
};

export const UpArrowIcon = (props) => {
  return <KeyboardArrowUpIcon {...props} />;
};

export const NotificationBellIcon = (props) => {
  return <NotificationsIcon {...props} />;
};

export const EditPenIcon = (props) => {
  return <EditIcon {...props} />;
};

export const BackArrowIcon = (props) => {
  return <ArrowBackIcon {...props} />;
};

export const ErrorTypeIcon = (props) => {
  return <ErrorIcon {...props} />;
};

export const RightTickIcon = (props) => {
  return <CheckCircleRoundedIcon {...props} />;
};

export const PersonNIcon = (props) => {
  return <PersonOutlineIcon {...props} />;
};

export const CircleOutlineIcon = (props) => {
  return <CircleOutlinedIcon {...props} />;
};

export const PersonAddIcon = (props) => {
  return <PersonAddAlt1Icon {...props} />;
};

export const PersonAddedIcon = (props) => {
  return <HowToRegIcon {...props} />;
};

export const ProfileIcon = (props) => {
  return <PersonIcon {...props} />;
};

export const OfferIcon = (props) => {
  return <LocalOfferIcon {...props} />;
};

export const CheckIcon = (props) => {
  return <DoneIcon {...props} />;
};

export const DeleteIconC = (props) => {
  return <DeleteIcon {...props} />;
};

export const BluetoothIconLine = (props) => {
  return <BluetoothIcon {...props} />;
};

export const HomeIconLine = (props) => {
  return <HomeIcon {...props} />;
};
export const WifiIconLine = (props) => {
  return <WifiIcon {...props} />;
};

export const CableIconLine = (props) => {
  return <CableIcon {...props} />;
};

export const ErrorOutlineIcon = (props) => {
  return <ErrorOutlineOutlinedIcon {...props} />;
};

export const RightArrowIcon = (props) => {
  return <NavigateNextIcon {...props} />;
};

export const DeleteIconO = (props) => {
  return <DeleteOutlinedIcon {...props} />;
};
export const InfoOutlineIcon = (props) => {
  return <InfoOutlinedIcon {...props} />
}

export const ClockIcon = (props) => {
  return <QueryBuilderIcon {...props} />
}
export const CircularProgressIcon = (props) => {
  return <CircularProgress {...props} />;
};
export const SettingsIcon = (props) => {
  return <SettingsOutlinedIcon {...props} />;
};
export const PrinterIcon = (props) => {
  return <PrintOutlinedIcon {...props} />;
};

export const InformationIcon = (props) => {
  return <InfoIcon {...props} />;
};

export const TicketIconOutlined = (props) => {
  return <ConfirmationNumberOutlinedIcon {...props} />;
};

export const PhotoIconOutlined = (props) => {
  return <InsertPhotoOutlinedIcon {...props} />;
};

export const RefreshIconFilled = (props) => {
  return <RefreshIcon {...props} />;
}

export const OfflineModeIcon = (props) => {
  return <WifiOffIcon {...props} />;
}

export const ArrowRight = (props) => {
  return <ArrowForward {...props} />;
}

export const ReportIcon = (props) => {
  return <ReportProblemIcon {...props} />;
}

export const LockedIcon = (props) => {
  return <LockIcon {...props} />
}

export const CashDrawerIcon = ({ bgcolor, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 25 25" fill="none">
    <path fillRule="evenodd" clipRule="evenodd" d="M0.908293 11.2915C0.827957 11.4143 0.78125 11.5611 0.78125 11.7188V17.9688C0.78125 19.2632 1.83058 20.3125 3.125 20.3125H21.875C23.1694 20.3125 24.2188 19.2632 24.2188 17.9688V11.7188C24.2188 11.5641 24.1738 11.4198 24.0962 11.2985L20.6528 5.78906C20.2245 5.10379 19.4734 4.6875 18.6653 4.6875H6.33484C5.52672 4.6875 4.77562 5.10379 4.34734 5.78906L0.908293 11.2915ZM2.97214 10.9375H6.72969C7.70668 10.9375 8.58117 11.5435 8.92422 12.4583L9.33566 13.5555C9.45004 13.8605 9.74152 14.0625 10.0672 14.0625H14.9328C15.2585 14.0625 15.55 13.8605 15.6643 13.5555L16.0758 12.4583C16.4188 11.5435 17.2933 10.9375 18.2703 10.9375H22.028L19.3278 6.61719C19.185 6.38875 18.9347 6.25 18.6653 6.25H6.33484C6.06547 6.25 5.81512 6.38875 5.67234 6.61719L2.97214 10.9375Z" fill={bgcolor} />
    <line x1="2.77783" y1="9.22217" x2="22.2223" y2="9.22217" stroke={bgcolor} />
  </svg>
)
